
import React from "react";
import { Label } from "@/components/ui/label";
import { FormFieldType } from "@/types/form";

interface FieldWrapperProps {
  element: FormFieldType;
  children: React.ReactNode;
}

export const FieldWrapper: React.FC<FieldWrapperProps> = ({ element, children }) => {
  return (
    <div className="mb-2">
      {element.label && (
        <Label htmlFor={element.id} className="block text-sm font-medium">
          {element.label}
          {element.required && <span className="text-red-500 ml-1">*</span>}
        </Label>
      )}
      {element.description && (
        <p className="text-sm text-gray-500 mt-1 whitespace-pre-line">{element.description}</p>
      )}
      {children}
    </div>
  );
};

export default FieldWrapper;
